import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatAutocompleteModule, MatSelectModule} from '@angular/material';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from "@angular/material/form-field";
import {ReactiveFormsModule} from '@angular/forms';
import {CityService} from '../service/city.service';
import {CityDropdownComponent} from './city-dropdown.component';

@NgModule({
    imports: [
        CommonModule,
        MatSelectModule,
        MatAutocompleteModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    exports: [
        CityDropdownComponent
    ],
    declarations: [CityDropdownComponent],
    providers: [CityService]
})
export class CityDropdownModule {
}